import React, { Component } from 'react';
import { Button, Input, Select, DatePicker, Tooltip, Icon, Checkbox, Cascader  } from 'antd';
import SearchRetrieve from '../common/SearchRetrieve.new.js';
import SearchMulRetrieve from '../common/SearchMulRetrieve';
import SelectProvince from '../common/SelectProvince';
import SelectAreaCity from '../common/SelectAreaCity';
import moment from 'moment';

const { Option } = Select;
const InputGroup = Input.Group;
const { MonthPicker, RangePicker } = DatePicker;
const monthFormat = 'YYYY-MM';
const dateFormat = 'YYYY-MM-DD';

/**
 * 搜索栏配置化
 *
 * @param {array} filters
 * 必须， 搜索栏字段配置列表
 * @param {object} params
 * 必须， 数据存储对象
 * @param {function} onChange
 * 必须， 更改数据的回调函数
 * @param {array} buttons
 * 不必须，额外需要渲染的button
 * @param {*} expandHeight
 * 不必须，展开/收起高度，默认不显示
 */

class FilterBasic extends Component {
    state = {
        expand: false
    }

    search = () => {
        this.props.search();
    }
    
    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.props.search();
        }
    }

    handleChange = (value, key) => {
        const { params, onChange } = this.props;
        params[key] = value;
        onChange(params, key);
    }

    handleRangeChange = (dates, dateStrings, keys) => {
        const { params, onChange } = this.props;
        const [begin, end] = dateStrings;
        params[keys[0]] = begin;
        params[keys[1]] = end;
        onChange(params, keys[0]);
    }

    handleRetrieveChange = (value, key) => {
        const { params, onChange } = this.props;
        params[key] = value;
        params[`${key}Id`] = value ? value.value : '';
        onChange(params, key);
    }
    
    saveProvince = (checkedArea) => {
        const { params, onChange } = this.props;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        onChange({
            params: {
                ...params,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    handleMulRetrieveChange = (value, option, key) => {
        const { params, onChange } = this.props;
        let list = params[key] || [];
        if (option) {
            list.push(option);
        } else {
            list = list.filter(i => i.value != value);
        }
        if (!value.length){
            list = [];
        }
        params[key] = list;
        params[`${key}Ids`] = list.map(i => i.value).join(',');
        onChange(params, key);
    }

    handleProvinceChange = (value, key) => {
        const { params, onChange } = this.props;
        params[key] = value.join(',');
        onChange(params, key);
    }

    handleDateChange = (data, dateString, key) => {
  
        const { params, onChange } = this.props;
        const dateStart = params[`dateStart`];
        const dateEnd = params[`dateEnd`];


        if (key === 'dateStart') {
            if (dateEnd) {
                if (moment(dateString).valueOf() > moment(dateEnd).valueOf()) {

                    params[`dateStart`] = dateEnd;
                    params[`dateEnd`] = dateString;
                    onChange(params, key);

                    return;
                } 
                // else if (moment(dateString).valueOf() === moment(dateEnd).valueOf()) {
                //     message.warning('不能选择单月！');
                //     return;
                // }
            }

            params[key] = dateString;
            onChange(params, key);

        } else if (key === 'dateEnd') {
            if (dateStart) {
                if (moment(dateString).valueOf() < moment(dateStart).valueOf()) {

                    params[`dateStart`] = dateString;
                    params[`dateEnd`] = dateStart;
                    onChange(params, key);

                    return;
                } 
                // else if (moment(dateString).valueOf() === moment(dateStart).valueOf()) {
                //     message.warning('不能选择单月！');
                //     return;
                // }
            }

            params[key] = dateString;
            onChange(params, key);
        } else {
                params[key] = dateString;
                onChange(params, key);
        }
    }

    disabledDate = (current) => {
        const value = moment().valueOf();
        return current && current.valueOf() > value;
    }

    getFilterType = (filter) => {
        const { params } = this.props;
        const { key, type, typeProperty = {}, group = [] } = filter;
        if (type === 'text') {
            return null;
        } else if (type === 'input') {
            const { style = {}, disabled = false, placeholder = '请输入' } = typeProperty;
            return (
                <Input
                    key={key}
                    value={params[key]}
                    disabled={disabled}
                    placeholder={placeholder}
                    style={{ width: 120, ...style }}
                    onKeyPress={this.handleKeyPress}
                    onChange={e => this.handleChange(e.target.value, key, type)}
                />
            )
        } else if (type === 'select') {
            const { list, style = {}, allowClear = true, disabled = false, mode = '', placeholder = "请选择", filterOption, showSearch } = typeProperty;
            const Options = list.map(i => <Option key={i.value} title = {i.label}> 
                <Tooltip placement="right" title={i.label}>
                    <span style={{ display: 'block', width: '100%', overflow: 'hidden' }}>{i.label}</span>
                </Tooltip>
            </Option>);
            return (
                <Select
                    key={key}
                    mode={mode}
                    disabled={disabled}
                    allowClear={allowClear}
                    placeholder={placeholder}
                    showSearch={showSearch}
                    filterOption={filterOption}
                    style={{ width: 100, ...style }}
                    value={params[key] || (mode === 'multiple' ? [] :undefined)}
                    onChange={value => this.handleChange(value, key, type)}
                >
                    {Options}
                </Select>
            )
        } else if (type === 'datePicker') {
            const { format = dateFormat, style = {}, allowClear = true, disabled = false } = typeProperty;
            const date = params[key];
            return (
                <DatePicker
                    key={key}
                    placeholder="请选择"
                    disabled={disabled}
                    allowClear={allowClear}
                    style={{ width: 100, ...style }}
                    value={date ? moment(date) : null}
                    onChange={(date, dateString) => this.handleChange(dateString, key, type)}
                    format={format}
                />
            )
        } else if (type === 'monthPicker') {
            const { format = monthFormat, style = {}, allowClear = true, disabled = false, ...rest } = typeProperty;
            const date = params[key];
            return (
                <MonthPicker
                    key={key}
                    placeholder="请选择"
                    disabled={disabled}
                    allowClear={allowClear}
                    style={{ width: 90, ...style }}
                    value={date ? moment(date) : null}
                    onChange={(date, dateString) => this.handleChange(dateString, key, type)}
                    format={format}
                    {...rest}
                />
            )
        }else if (type === 'monthPickerRange') {
            const { format = monthFormat, keys = [], style = {}, disabled = false, ...rest } = typeProperty;
            const dateStart = params[keys[0]];
            const dateEnd = params[keys[1]];
            return (
                <div className="search-item month-range-picker" style={{...style}}>
                <MonthPicker
                    className="begin"
                    format={monthFormat}
                    value={dateStart ? moment(dateStart) : null}
                    allowClear={false}
                    placeholder="开始月份"
                    style={{ width: 90 }}
                    //disabledDate={this.disabledDate}
                    //onChange={(date, dateString) => this.handleChange(dateString, 'dateStart', type)}
                    onChange={(date, dateString) => this.handleDateChange(date, dateString, 'dateStart')}
                    {...rest}
                />
                <MonthPicker
                    className="end"
                    format={monthFormat}
                    value={dateEnd ? moment(dateEnd) : null}
                    allowClear={false}
                    placeholder="结束月份"
                    style={{ width: 90 }}
                    //disabledDate={this.disabledDate}
                    //onChange={(date, dateString) => this.handleChange(dateString, 'dateEnd', type)}
                    onChange={(date, dateString) => this.handleDateChange(date, dateString, 'dateEnd')}
                    {...rest}
                />
            </div>
            )
        } else if (type === 'rangePicker') {
            const { format = dateFormat, keys = [], style = {}, allowClear = true, ...rest } = typeProperty;
            const begin = params[keys[0]];
            const end = params[keys[1]];
            return (
                <RangePicker
                    placeholder={["请选择", "请选择"]}
                    allowClear={allowClear}
                    style={{ width: 220, ...style }}
                    value={[begin ? moment(begin) : null, end ? moment(end) : null]}
                    onChange={(dates, dateStrings) => this.handleRangeChange(dates, dateStrings, keys)}
                    format={format}
                    {...rest}
                />
            )
        } else if (type === 'searchRetrieve') {
            const value = params[key];
            return (
                <SearchRetrieve
                    {...typeProperty}
                    value={value ? value.text : undefined}
                    onChange={value => this.handleRetrieveChange(value, key)}
                />
            )
        } else if (type === 'searchMulRetrieve') {
            const ids = params[`${key}Ids`];
            const idList = ids ? ids.split(',') : [];
            return (
                <SearchMulRetrieve
                    {...typeProperty}
                    value={idList}
                    onChange={(value, option) => this.handleMulRetrieveChange(value, option, key)}
                />
            )
        } else if (type === 'selectProvince') {
            const { saveProvince, ...rest } = typeProperty;
            return (
                <SelectProvince
                    {...rest}
                    saveProvince={value => saveProvince ? saveProvince(value) : this.handleProvinceChange(value, key)}
                />
            )
        } else if (type === 'selectAreaCity') {
            const { ...rest } = typeProperty;
            return (
                <SelectAreaCity
                    {...rest}
                    value={params[key]}
                    onChange={value => this.handleChange(value, key, type)}
                />
            )
        } else if (type === 'inputGroup') {
            return (
                <InputGroup compact>
                    {group.map(item => this.getFilterType(item))}
                </InputGroup>
            )
        } else if (type === 'Checkbox') {
            return (
                <div style={{paddingTop:'5px'}}>
                    <Checkbox 
                        onChange={e => this.handleChange(e.target.checked, key, type)}>
                        {typeProperty.value}
                    </Checkbox>
                </div>
            )
        } else if (type === 'Cascader') {
            const { options, allowClear = true, disabled = false } = typeProperty;
            return (
                <Cascader 
                    placeholder="请选择"
                    value={params[key]}
                    allowClear={allowClear}
                    disabled={disabled}
                    options={options}
                    onChange={value => this.handleChange(value, key)}
                />
            )
        }
        return null;
    }

    getConent = () => {
        const { filters } = this.props;
        const list = (filters || []).map(filter => {
            const { key, name } = filter;
            return (
                <div key={key || name} className="search-item">
                    <div className="ui-label">{name}</div>
                    {this.getFilterType(filter)}
                </div>
            );
        });
        return list;
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    render() {
        const { expand } = this.state;
        const { search, buttons, operable = true, expandHeight = 0 } = this.props;
        const hasSearch = !!search;
        const maxHeight = expand ? expandHeight : (expandHeight ? 38 : 'none');
        return (
            <div style={{marginBottom: 16}}>
                <div
                    className="search-bar expand"
                    style={{ minHeight: 38, maxHeight: maxHeight }}
                >
                    {
                        !!expandHeight &&
                        <div className="expand-box">
                            <a onClick={this.toggleHeight} >
                                {expand ? "收起" : "展开"}
                                <Icon className="expand-icon" type={expand ? "up" : "down"} />
                            </a>
                        </div>
                    }
                    {hasSearch && this.getConent()}
                    {
                        !expandHeight &&
                        <div className="search-item">
                            { hasSearch && <Button key="search" type="primary" disabled={!operable} onClick={this.search}>搜索</Button> }
                            {buttons}
                        </div>
                    }
                </div>
                {
                    !!expandHeight &&
                    <div className="search-bar flex-end">
                        <div className="search-item">
                            { hasSearch && <Button key="search" type="primary" disabled={!operable} onClick={this.search}>搜索</Button> }
                            {buttons}
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default FilterBasic;


// WEBPACK FOOTER //
// ./src/components/basicElement/FilterBasic.js